const prostate = [

    { 
    label:"Side",
    controlType:"checkbox group",
    options:["Right", "Left", "Central"]
    },

]

export default prostate